import { api } from "@/lib/api";

const TOKEN_KEY = "jo_admin_token";

export const auth = {
  getToken: () => localStorage.getItem(TOKEN_KEY),
  setToken: (t) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => localStorage.removeItem(TOKEN_KEY),
  isAuthed: () => !!localStorage.getItem(TOKEN_KEY),
};

// Attach Authorization header automatically when token present
api.interceptors.request.use((config) => {
  const t = auth.getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) auth.clear();
    return Promise.reject(err);
  }
);
